"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _reactRedux = require("react-redux");
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _formulaVariables = _interopRequireDefault(require("../../formulaVariables.graphql"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var elementIcons = {};
_cccisdLaravelFlow.allElements.forEach(function (element) {
  elementIcons[element.code] = element.icon;
});
var ConditionsPicker = function ConditionsPicker(props) {
  var onChange = props.onChange,
    closeModal = props.closeModal;
  var currentAssignmentId = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentAssignmentId;
  });
  var graphqlVariables = {
    assignmentId: currentAssignmentId,
    variableId: 0,
    typeFilter: ['quantitative', 'qualitative', 'formula', 'additional_coding']
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    query: _formulaVariables["default"],
    rowKey: "reportHeader",
    graphqlVariables: graphqlVariables,
    perPage: 10,
    onRowClick: function onRowClick(row) {
      onChange({
        id: row.reportHeader,
        title: row.reportHeader,
        type: 'string'
      });
      closeModal();
    },
    columns: [{
      name: 'key.title',
      label: 'Question',
      rowSpanBy: 'key.entityId',
      filter: true,
      render: function render(_ref) {
        var value = _ref.value,
          row = _ref.row;
        var type = row['key.entity.type'];
        return type ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].questionType
        }, elementIcons[type] && /*#__PURE__*/_react["default"].createElement("div", null, elementIcons[type]), /*#__PURE__*/_react["default"].createElement("div", null, type)), value) : value;
      }
    }, {
      name: 'key.metric',
      label: 'Metric',
      filter: true
    }, {
      name: 'reportHeader',
      label: 'Variable',
      filter: true
    }, {
      name: 'label',
      label: 'Label',
      filter: true
    }]
  });
};
var _default = exports["default"] = ConditionsPicker;